import React, { useState } from 'react'

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('');
    setError('');
    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    setLoading(true);
    try {
      const response = await fetch('https://evercorenutrition.com/ev_admin/api/newsletter/subscribe/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await response.json();
      if (response.ok && (data.success || data.message)) {
        setSuccess(data.message || 'Successfully subscribed to our newsletter!');
        setEmail('');
      } else {
        setError(data.message || data.error || 'Subscription failed. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    section: {
      background: 'url("/assets/images/kk.png") no-repeat center/cover',
      width: '100%',
      maxWidth: '100vw',
      overflowX: 'hidden',
      boxSizing: 'border-box',
      margin: '50px 0',           /* ✅ outer top/bottom spacing */
      padding: '60px 16px 16px 16px',       /* ✅ inner breathing room top/bottom */
    },
    inner: {
      width: '100%',
      maxWidth: '550px',          /* ✅ fixed to 550px as requested */
      boxSizing: 'border-box',
      marginLeft: 0,              /* ✅ left-aligned so berries show on right */
    },
    card: {
      background: 'rgba(255,255,255,0.92)',
      backdropFilter: 'blur(4px)',
      borderRadius: '16px',
      padding: '36px 32px',       /* ✅ good inner card padding */
      display: 'flex',
      flexDirection: 'column',    /* ✅ stacked: title on top, form below */
      gap: '20px',
      boxSizing: 'border-box',
      width: '100%',
    },
    title: {
      fontSize: 'clamp(20px, 4vw, 26px)',
      fontWeight: '700',
      margin: '0 0 4px 0',
      color: '#111',
    },
    subtitle: {
      fontSize: '14px',
      color: '#666',
      margin: 0,
    },
    fieldWrap: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #ccc',
      borderRadius: '8px',
      padding: '0 12px',
      background: '#fff',
      gap: '8px',
      height: '48px',
      boxSizing: 'border-box',
      width: '100%',
    },
    input: {
      border: 'none',
      outline: 'none',
      flex: 1,
      fontSize: '14px',
      background: 'transparent',
      minWidth: 0,
    },
    icon: {
      color: '#888',
      fontSize: '14px',
      flexShrink: 0,
    },
    button: {
      height: '48px',
      background: '#111',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      fontSize: '15px',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      width: '100%',
      marginTop: '4px',           /* ✅ small gap between field and button */
      boxSizing: 'border-box',
    },
  };

  return (
    <section style={styles.section}>
      <div style={styles.inner}>
        <div style={styles.card}>

          {/* Text block */}
          <div>
            <h2 style={styles.title}>Newsletter</h2>
            <p style={styles.subtitle}>Subscribe to our newsletter</p>
          </div>

          {/* Form block */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={styles.fieldWrap}>
              <i className="fa-solid fa-envelope" style={styles.icon}></i>
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                style={styles.input}
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading}
              style={{
                ...styles.button,
                opacity: loading ? 0.7 : 1,
                cursor: loading ? 'not-allowed' : 'pointer',
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status"></span>
                  Subscribing...
                </>
              ) : (
                <>
                  Subscribe
                  <i className="fa-solid fa-arrow-right" style={{ fontSize: '13px' }}></i>
                </>
              )}
            </button>

            {success && (
              <p style={{ color: '#28a745', fontSize: '13px', margin: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                <i className="fa-solid fa-circle-check"></i>{success}
              </p>
            )}
            {error && (
              <p style={{ color: '#dc3545', fontSize: '13px', margin: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                <i className="fa-solid fa-circle-xmark"></i>{error}
              </p>
            )}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Newsletter;